import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GeoAddress,
  GeoCoordinatesRequest,
} from 'planning-portal-library/src/lib/core/domain';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { GeoCoordinateRepository } from 'planning-portal-library/src/lib/core/repositories/geo-coordinate.repository';
import { catchError, map, Observable } from 'rxjs';
import { BaseResponse } from '../../../shared/base.response';
import { GeoAddressWebEntity } from './entities/geo-address-web-entity';
import { GeoAddressWebRepositoryMapper } from './entities/geo-address-web-repository-mapper';
import { GeoCoordinatesApiUrls } from './geo-coordinates-api-urls';

@Injectable({ providedIn: 'root' })
export class GeoCoordinatesWebRepository extends GeoCoordinateRepository {
  geoAddressMapper = new GeoAddressWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getGeoCoordinates(request: GeoCoordinatesRequest): Observable<GeoAddress> {
    return this.http
      .post<BaseResponse<GeoAddressWebEntity>>(
        `${this.environment.mapServiceUrl}${GeoCoordinatesApiUrls.ConvertAddressToLatLng}`,
        request
      )
      .pipe(
        map((data: BaseResponse<GeoAddressWebEntity>) => {
          return data.result!;
        }),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.geoAddressMapper.mapFrom));
  }
}
